import * as React from "react"
import { RNQRCodeScannerProps } from "react-native-qrcode-scanner"

const QRCodeScanner: React.FC<RNQRCodeScannerProps> = (props) => {
  return <></>
}

export { QRCodeScanner }
